import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundToInt',
  standalone: true,
})
export class RoundToIntPipe implements PipeTransform {
  transform(value: number): string {
    if (isNaN(value)) return '0';
    return Math.round(value).toFixed(0);
  }
}
